import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ vehicleData, onNewScan }) => {
  const navigate = useNavigate();

  const quickActionItems = [
    {
      label: 'Neuer Scan',
      icon: 'Scan',
      action: onNewScan,
      variant: 'outline',
      description: 'Weitere VIN scannen'
    },
    {
      label: 'Aufträge anzeigen',
      icon: 'ClipboardList',
      action: () => navigate('/order-management-dashboard'),
      variant: 'ghost',
      description: 'Alle Aufträge'
    },
    {
      label: 'Techniker',
      icon: 'Users',
      action: () => navigate('/technician-assignment'),
      variant: 'ghost',
      description: 'Techniker-Übersicht'
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center mb-4">
        <Icon name="Zap" size={18} className="text-primary mr-2" />
        <h3 className="text-sm font-semibold text-foreground">Schnellaktionen</h3>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {quickActionItems?.map((item, index) => (
          <Button
            key={index}
            variant={item?.variant}
            onClick={item?.action}
            disabled={item?.disabled}
            className="h-auto p-4 flex flex-col items-center text-center"
          >
            <Icon name={item?.icon} size={20} className="mb-2" />
            <span className="text-sm font-medium">{item?.label}</span>
            <span className="text-xs opacity-75 mt-1">{item?.description}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;